import { z } from 'zod';
import { DeploymentEnvironment } from '@hclinear/hc-linear-react';

export const runtimeConfigSchema = z.object({
  DEPLOYMENT_ENVIRONMENT: z.nativeEnum(DeploymentEnvironment),

  BACKEND_URL: z.string().url().min(1),
  AUTH_BACKEND_URL: z.string().url().min(1),
  AUTH_FRONTEND_URL: z.string().url().min(1),

  GOOGLE_MAPS_API_KEY: z.string().min(1),

  SENTRY_DSN: z.string().url().min(1).optional(),
});
